// src/components/profile/ProfileLink.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserProfilePicture from './UserProfilePicture';

const ProfileLink = ({ 
  profileId, 
  photoURL, 
  altText = "Profile", 
  size = 'w-12 h-12', 
  onClick, 
  source,
  isPremium,
  isArtist = false
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // Stop the click from bubbling up to a parent element (like a song tile)
    e.stopPropagation(); 

    if (profileId && source) {
    }

    if (onClick) {
      onClick();
    }
    
    if (profileId) {
      navigate(`/profile/${profileId}`);
    } else {
      console.error("ProfileLink: No profileId provided.");
    }
  };

  const finalPremiumCheck = isArtist ? false : isPremium === true;

  return (
    <div onClick={handleClick} className="cursor-pointer hover:scale-105 transition-transform inline-block">
      {/* 🌟 UPGRADED: Replaced raw <img> with full context-aware component */}
      <UserProfilePicture 
        photoURL={photoURL}
        sizeClass={size}
        isPremium={finalPremiumCheck}
        shape="circle"
      />
    </div>
  );
};

export default ProfileLink;